import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-process-labor-productivity',
  templateUrl: './process-labor-productivity.component.html',
  styleUrls: ['./process-labor-productivity.component.css']
})
export class ProcessLaborProductivityComponent implements OnInit {

  form;
  ngOnInit () {

    this.form = new FormGroup ( {

    value1: new FormControl(''),
    value2: new FormControl(''),
    } )

  } 
  labPro(n1,n2){
    var labProd=n1/n2;
    var labProdpercent= labProd*100;
    var labProdsimple= labProdpercent.toFixed(2);
    return labProdsimple ;
    }
}



// WEBPACK FOOTER //
// C:/my-dream-app/src/app/process-labor-productivity/process-labor-productivity.component.ts